module.exports = __webpack_public_path__ + "static/media/ex7.cbb40c7e.mp3";